import _ from "lodash";

export default {
    /**
     * This method will normalize client's locale to appropriate moment's locale abbreviation.
     *
     * Currently there is an issue where Norwegian locale is abbreviated with 'no' or 'nor' but
     * the moment is expecting 'nb'. This method will be responsible for correctly mapping
     * any discrepancies and return appropriate locale abbreviation needed by moment.
     *
     * @param {String} locale - Current application locale
     * @return {String} normalized moment's locale
     */
    normalizeMomentLocale: function (locale) {
        const tempLocale = _.lowerCase(locale);

        //correctly handle norwegian mapping
        if (tempLocale === "no" || tempLocale === "nor") {
            return "nb";
        } else if (tempLocale === "en us") {
            return "en";
        }
        return locale;
    },
};
